class StaffListController {
  constructor(StaffFactory, $rootScope, $filter, $state, ngDialog, URLS) {
    "ngInject";
    const vm = this;

    let $translate = $filter("translate");

    vm.rootScope = $rootScope;

    vm.$onInit = () => {
      reloadStaff();
    };

    vm.gridOptions = {
      enableSorting: true,
      paginationPageSizes: [50, 100, 150],
      paginationPageSize: 50,
      enableColumnMenus: false,
      enableFiltering: true,
      columnDefs: [
        {
          field: "image",
          name: "",
          enableFiltering: false,
          cellTemplate:
            '<div class="ui-grid-cell-contents ui-grid-align-c p-t-0">' +
            '<span class="avatar w-32">' +
            '<img ng-src="{{grid.appScope.vm.getStaffImage(row.entity)}}">' +
            '<i class="on b-white bottom"></i>' +
            "</span>" +
            "</div>",
          width: "80",
        },
        {
          field: "code",
          enableFiltering: false,
          name: $translate("CODE"),
          width: "110",
        },
        {
          field: "staffName",
          name: $translate("NAME"),
          enableFiltering: true,
        },
        {
          field: "type",
          name: $translate("TYPE"),
          enableFiltering: true,
        },
        {
          field: "actions",
          enableFiltering: false,
          name: $translate("ACTIONS"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            '<div class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            '<div class="buttons">' +
            '<a href class="btn btn-sm btn-info m-l-1" translate ' +
            'ng-click="grid.appScope.vm.goToProfile(row.entity.id)">PROFILE</a>' +
            '<button class="btn btn-sm btn-warning m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_STAFF)" ' +
            'ng-click="grid.appScope.vm.goToEdit(row.entity.id)">EDIT</button>' +
            '<button class="btn btn-sm btn-danger m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_STAFF)" ' +
            'ng-click="grid.appScope.vm.deleteStaff(row.entity.id)">DELETE</button>' +
            '<button class="btn btn-sm accent m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.VALIDATE_PASSPORT)" ' +
            'ng-click="grid.appScope.vm.getCard(row.entity.id)">DOWNLOAD_CARD</button>' +
            "</div>" +
            "</div>",
          width: "400",
        },
      ],
    };

    vm.getCard = (staff) => {
      const tabWindowId = window.open("about:blank", "_blank");
      StaffFactory.card(staff).then((response) => {
        let file = new Blob([response.data], { type: "application/pdf" });
        tabWindowId.location.href = window.URL.createObjectURL(file);
      });
    };

    vm.hasPermission = (permission) => {
      return vm.rootScope.user.canDo(permission);
    };

    vm.getStaffImage = function (entity) {
      if (entity.img) {
        return URLS.IMAGES_URL + "/staff/" + entity.img;
      } else {
        return "assets/images/no_avatar.png";
      }
    };

    vm.goToProfile = (staffId) => {
      $state.go("staff-profile", { id: staffId });
    };

    vm.goToEdit = (staffId) => {
      $state.go("staff-edit", { id: staffId });
    };

    vm.deleteStaff = (staffId) => {
      ngDialog
        .openConfirm({
          template: "confirmTemplate",
          data: {
            message: $translate("CONFIRM_DELETE_STAFF"),
          },
        })
        .then(() => {
          StaffFactory.delete(staffId).then((response) => {
            ngDialog.open({ template: "successTemplate" });
            reloadStaff();
          });
        });
    };

    function reloadStaff() {
      StaffFactory.getAll().then((response) => {
        vm.gridOptions.data = response.data;
      });
    }
  }
}

export default StaffListController;



// WEBPACK FOOTER //
// ./client/app/components/staff/staffList/staffList.controller.js